import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import type { ErrorCustom } from '@/utils/client';
import { get } from '@/utils/client';

// Types
import type { GiveawayResult } from '@/components/pages/giveaway-picker/Types/drawTypes';

// Routes
import { GIVEAWAY_PICKER_RESULT } from '@/routes/apiToolsEndpoints';

const useGiveawayPickerResults = (
    giveawayId: number,
    signature: string,
    options?: SWRConfiguration<GiveawayResult, ErrorCustom>
) => {
    const { data, error, isLoading } = useSWR<GiveawayResult, ErrorCustom>(
        giveawayId && signature
            ? `${GIVEAWAY_PICKER_RESULT}/${giveawayId}?signature=${signature}`
            : null,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        giveawayResultsData: data,
        giveawayResultsError: error,
        isLoading
    };
};

export default useGiveawayPickerResults;
